import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { baseUrl } from "../Common/data";
import useWishlist from "../hooks/useWishlist";

function CollectionsWithHotels() {
  const { locationId } = useParams();
  const [collections, setCollections] = useState([]);
  const [filteredCollections, setFilteredCollections] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [locationName, setLocationName] = useState("");
  const navigate = useNavigate();
  const { isInWishlist, toggleWishlist } = useWishlist();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${baseUrl}/api/hotel/collections/with-hotels`,
        );
        if (res.status === 200) {
          const data = res.data.data || [];
          
         const filteredCollections = locationId
          ? data
              .map((collection) => {
                const filteredHotels = (collection.hotels || []).filter(
                  (h) => h.location?._id === locationId
                );
                return { ...collection, hotels: filteredHotels };
              })
              .filter((collection) => collection.hotels.length > 0)
          : data.filter((collection) => (collection.hotels || []).length > 0);

        setCollections(filteredCollections);
        setFilteredCollections(filteredCollections);
        }
      } catch (error) {
        console.error("Error fetching collections with hotels:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    if (!query.trim()) {
      setFilteredCollections(collections);
    } else {
      const filtered = collections.filter((c) =>
        c.collectionName.toLowerCase().includes(query.toLowerCase()),
      );
      setFilteredCollections(filtered);
    }
  };

  const handleHotelClick = (id) => {
    window.open(`/collectiondetail/${id}`, "_blank");
  };

  const handleWishlistClick = async (e, hotelId) => {
    e.stopPropagation();
    const token = localStorage.getItem("token");
    if (!token) return alert("Please login to add to wishlist.");
    await toggleWishlist(hotelId);
  };

  return (
    <>
      <Navbar />
      <div className="col-banner">
        <div className="search-bar search-bar2">
          {/* <h2>All Collections</h2> */}
          <div className="search-bar-div">
            <input
              placeholder="Search Property "
              value={searchQuery}
              onChange={handleSearch}
            />
            <i className="bi bi-search"></i>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loader-container">
          <span className="loader"></span>
        </div>
      ) : (
        <div className="collection-rad">
          {filteredCollections.length > 0 ? (
            filteredCollections.map((collection) => (
              <div key={collection._id}>
                <div className="bar-heading">
                  <p>{collection.collectionName}</p>
                </div>
                <div className="trending-cards" style={{ flexWrap: "nowrap" }}>
                  {collection.hotels.map((hotel) => (
                    <div key={hotel._id}>
                      <div
                        className="trending-card trending-card010"
                        onClick={() => handleHotelClick(hotel._id)}
                      >
                        <div
                          className="wishlist-icon"
                          onClick={(e) => handleWishlistClick(e, hotel._id)}
                        >
                          <i
                            className={
                              isInWishlist(hotel._id)
                                ? "bi bi-heart-fill"
                                : "bi bi-heart"
                            }
                          ></i>
                        </div>
                        <img
                          src={hotel?.images?.profile}
                          alt={hotel?.propertyName}
                          className="hotel-image"
                        />
                        <div className="trending-text">
                          <h3>{hotel?.propertyName}</h3>
                          <div className="trending-text-line">
                            <p>
                              <i className="bi bi-geo-alt-fill"></i>{" "}
                              {hotel?.city}
                            </p>
                          </div>
                          <div className="trending-text-line2">
                            <p>
                               {hotel?.guestCapacity} Guest ✦{" "}
                              {hotel?.totalRooms} {hotel?.totalRoomsType === "beds" ? "Beds" : "Rooms"} ✦{" "}
                              {hotel?.poolSize?.length} X{" "}
                              {hotel?.poolSize?.breadth} Pool
                            </p>
                          </div>
                          <div className="trending-text-line">
                            <h2>
                              ₹ {hotel?.listingprice || ""}{" "}
                              <span>
                                /{" "}
                                {hotel?.priceType === "per_person"
                                  ? "Person"
                                  : "Night"}
                              </span>
                            </h2>
                            <button>Book Now</button>
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <p style={{ padding: "40px 50px" }}>No collections found.</p>
          )}
        </div>
      )}
      <Footer />
    </>
  );
}

export default CollectionsWithHotels;
